import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const Marche = () => {
    let location = useLocation();
    return (
        <div>
            <Helmet>
                <title>Comment ça marche</title>
                <meta name='description' content='Comment ça marche e-kaly.' />
                <link rel='canonical' href={location.pathname} />
            </Helmet>
            <h1>Commet ça marche</h1>
        </div>
    )
}

export default Marche